import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useModalsStore = defineStore('modals', () => {
  const showCreateCard = ref(false)

  function openCreateCard() {
    showCreateCard.value = true
  }

  function closeCreateCard() {
    showCreateCard.value = false
  }

  return { showCreateCard, openCreateCard, closeCreateCard }
})
